import { render, staticRenderFns } from "./CustomProofInput.vue?vue&type=template&id=2ebd8485&scoped=true"
import script from "./CustomProofInput.vue?vue&type=script&lang=js"
export * from "./CustomProofInput.vue?vue&type=script&lang=js"
import style0 from "./CustomProofInput.vue?vue&type=style&index=0&id=2ebd8485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd8485",
  null
  
)

export default component.exports